import React, { memo, useState } from 'react';
import PlayerTimelineButton from './PlayerTimelineButton';
import ConfirmationDialog from '@/components/organisms/ConfirmationDialog';
import useDialog from '@/components/organisms/useDialog';
import { resetFullClipChanges } from '@/libs/fullRecordingEdit';
import { useClipsContext } from '@/context/ClipsContext/ClipsContext';
import { useRemotionPlayerPause } from '@/App/remotion/MainPlayer/ClipPlayerV2WithNewTimeline/hooks/useRemotionPlayerPause';
import EventBus from '@/libs/eventBus/eventBus';
import { CustomEvents } from '@/libs/eventBus/constants';

function RevertChange() {
  const [revertingChanges, setRevertingChanges] = useState(false);

  const { pause } = useRemotionPlayerPause();
  const { clipId } = useClipsContext();
  const {
    isOpen: isResetChangesDialogOpen,
    openDialog: openResetChangesDialog,
    closeDialog: closeResetChangesDialog
  } = useDialog();

  async function resetFullRecordingChanges() {
    pause();
    setRevertingChanges(true);
    resetFullClipChanges(clipId);

    EventBus.dispatch(CustomEvents.ClearAiChat, { silent: true });

    closeResetChangesDialog();
  }

  return (
    <>
      <PlayerTimelineButton
        tooltipTitle={revertingChanges ? 'Reverting...' : 'Discard all edits'}
        buttonId="new-timeline-revert-changes-button"
        onClick={openResetChangesDialog}
        isLoading={revertingChanges}
        iconName={'IconRestore'}
      />
      <ConfirmationDialog
        isOpen={isResetChangesDialogOpen}
        onClose={closeResetChangesDialog}
        onConfirm={resetFullRecordingChanges}
        title="Revert Changes"
        content="Are you sure you want to revert to the original version of this video? Your current changes will be lost."
        confirmLabel="Revert Changes"
      />
    </>
  );
}

export default memo(RevertChange);
